"use client"

import styled from "@emotion/styled"
import Container from "ui/Container"
import { sharedColors } from "ui/theme/colors"
import { extractProperty, replaceRichTextLinks } from "utils"
import { StyledTypographyWithTable } from "./FaqItem"

const OuterContainer = styled.div<{ $isGray?: boolean }>`
  width: 100%;
  background-color: ${({ $isGray }) =>
    $isGray ? sharedColors.mediumGrayLight : "transparent"};
`

const StyledProperty = styled.div`
  padding-top: 32px;
  padding-bottom: 48px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 48px;
    padding-bottom: 64px;
  }

  /* table {
    border-collapse: collapse;
    width: 100%; // Make table take full width of container
    display: flex;
    overflow-x: auto; // Allow horizontal scrolling if needed
  }

  th,
  td {
    border: 1px dashed gray;
    padding: 8px; // Add some padding
  } */
`

const StyledTypography = styled(StyledTypographyWithTable)<{
  component?: string
}>`
  p {
    margin: 0;
  }
`

type Props = {
  data: any
  blockIndex?: number
  isHomepage?: boolean
}

export default function TabsContent({ data, blockIndex, isHomepage }: Props) {
  const tabsContent = data?.properties?.[0]?.propertyValue?.blocks?.[0]
  const itemsList = extractProperty(tabsContent, "itemsList")
  const items = itemsList.map((item: any) => {
    return {
      content: extractProperty(item, "content"),
    }
  })
  const isGray =
    isHomepage && typeof blockIndex === "number" && blockIndex % 2 === 1
  return (
    <OuterContainer $isGray={isGray}>
      <Container paddingMobile>
        <StyledProperty>
          <StyledTypography
            component="div"
            dangerouslySetInnerHTML={{
              __html: replaceRichTextLinks(items?.[0]?.content),
            }}
          />
        </StyledProperty>
      </Container>
    </OuterContainer>
  )
}
